import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateWorkbookReminderPayload, GetWorkbookReminderPayload, UpdateWorkbookReminderPayload } from '../models/workbook-reminder.models';
import { AddCommentPayload, UpdateCommentPayload, UpdateCommentStatusPayload, WBCreateCommentCategory } from '../models/workbook-comment.models';

@Injectable({
  providedIn: 'root'
})
export class WorkbookCommentService {
  dynamicTableAPI: string;
  constructor(private readonly http: HttpClient) {
    this.dynamicTableAPI = environment.dynamicTableAPI; 
   }
  // comment service
  getWorkbookRowComment(workbookId: string, rowNumber: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/Comment`);
  }

  getWBParentComment(workbookId: string, rowNumber: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/ParentComments`);
  }

  getWBChildComment(workbookId: string, rowNumber: number, parentId:string): Observable<any[]> {
    return this.http.get<any[]>(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/ParentComment/${parentId}/ChildComments`);
  }  

  createWorkbookRowComment(workbookId: string, addCommentPayload:any, rowNumber: number): Observable<any> {
    return this.http.post<any>(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/Comment`, addCommentPayload, {});
  }

  updateWorkbookRowComment(workbookId: string, updateCommentPayload:UpdateCommentPayload, rowNumber: number): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/Comment`, updateCommentPayload);
  }

  deleteWorkbookRowComment(workbookId: string, commentId: any, rowNumber: number) {
    return this.http.delete<any>(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/Comment/${commentId}`);
  }

  // updateReadStatus
  updateWorkbookCommentStatus(workbookId: string, updateCommentStatusPayload:UpdateCommentStatusPayload, rowNumber: number): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/AddOrChangeCommentStatus`, updateCommentStatusPayload);
  }
     
  // updateWorkbookRowCommentStatus
  updateWorkbookRowCommentStatus(workbookId: string, isRead:boolean, rowNumber: number): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/AddOrChangeAllCommentStatus`, isRead);
  }

  //updateParentCommentStatus
  updateParentCommentStatus(workbookId: string, isRead:boolean, rowNumber: number): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/ParentCommentStatus`, isRead);
  }

  //updateParentCommentStatus
  updateChildCommentStatus(workbookId: string, isRead:boolean, rowNumber: number, parentId:string): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/ParentComment/${parentId}/ChildCommentStatus`, isRead);
  }

  //comment category service
  getCommentCategory(): Observable<any[]> {
    return this.http.get<any[]>(`${this.dynamicTableAPI}CommentCategory`);
  }
  createCommentCategory(wbCreateCommentCategory: WBCreateCommentCategory): Observable<any> {
    return this.http.post<any>(`${this.dynamicTableAPI}CommentCategory`, wbCreateCommentCategory, {});
  }

  updateCommentCategory(wbUpdateCommentCategory: any): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}CommentCategory`, wbUpdateCommentCategory);
  } 

  deleteCommentCategory(commentCategoryId: string): Observable<any> {
    return this.http.delete(`${this.dynamicTableAPI}CommentCategory/${commentCategoryId}`);
  } 
  //comment category service
  //Delete Commennt Attachment
  deleteWBRowCommentAttachment(attachmentId: number): Observable<any> {
    return this.http.delete<any>(`${this.dynamicTableAPI}Workbook/Attachment/${attachmentId}`);
  }
}
